/**
 * Cabinet Decisions Mock Data for GovTrack Namibia
 *
 * Entities follow schemas defined in DevPlan/Cabinet.md sections 3.2–3.5.
 * CDN format: "{SEQ}TH/{DD.MM.YY}/{SEQ}"
 *
 * Ministry codes (2025 restructuring):
 *   MODVA, MHAISS, MIRT, MFSGM, MAFWLR, MEIYSC, MHSS, MIME,
 *   MJL, MWTI, MEFT, MURDH, MICT, GEPSW, OP, OPM
 */

// ---------------------------------------------------------------------------
// 3.4  Assignments
// ---------------------------------------------------------------------------
const assignments = [
  // === Assignments for DIR-2025-001-01 (Housing land allocation) ===
  {
    id: 'ASG-001-01-A',
    parentDirectiveId: 'DIR-2025-001-01',
    parentDecisionId: 'CAB-2025-001',
    taskDescription: 'Complete land survey and identification in Khomas Region',
    assignedTo: {
      name: 'Mr. K. Nepemba',
      role: 'Regional Land Surveyor',
      title: 'Deputy Director: Land Use Planning',
      ministry: 'MURDH',
      directorate: 'Land Use Planning Directorate',
      division: 'Regional Surveys Division',
      email: 'k.nepemba@murdh.gov.na'
    },
    assignedBy: { name: 'Mr. F. Nghidishange', role: 'Executive Director', ministry: 'MURDH' },
    assignedDate: '2025-03-25',
    status: 'Completed',
    priority: 'high',
    progress: 100,
    startDate: '2025-04-01',
    deadline: '2025-05-15',
    completedDate: '2025-05-10',
    checklistItems: [
      { id: 'CK-01', item: 'Obtain aerial survey data from Lands Ministry', completed: true },
      { id: 'CK-02', item: 'Conduct on-site assessment of identified parcels', completed: true },
      { id: 'CK-03', item: 'Prepare survey report with GPS coordinates', completed: true },
      { id: 'CK-04', item: 'Submit report to ED for approval', completed: true }
    ],
    evidenceAttachments: [
      { name: 'KHOMAS_LAND_SURVEY_2025.pdf', uploadedAt: '2025-05-08T10:00:00Z', type: 'application/pdf' },
      { name: 'SITE_PHOTOS_KHOMAS.zip', uploadedAt: '2025-05-08T10:05:00Z', type: 'application/zip' }
    ],
    notes: 'Survey completed. 450 hectares identified across 3 locations.',
    comments: [
      { id: 'CMT-001', author: 'Mr. K. Nepemba', date: '2025-04-15T14:00:00Z', text: 'Preliminary survey of Windhoek West completed. Proceeding to Klein Windhoek.' },
      { id: 'CMT-002', author: 'Mr. F. Nghidishange', date: '2025-05-10T09:00:00Z', text: 'Report reviewed and approved. Good work.' }
    ],
    lastUpdated: '2025-05-10T09:30:00Z'
  },
  {
    id: 'ASG-001-01-B',
    parentDirectiveId: 'DIR-2025-001-01',
    parentDecisionId: 'CAB-2025-001',
    taskDescription: 'Complete land survey and identification in Erongo Region',
    assignedTo: {
      name: 'Ms. R. Garises',
      role: 'Regional Land Surveyor',
      title: 'Deputy Director: Land Use Planning',
      ministry: 'MURDH',
      directorate: 'Land Use Planning Directorate',
      division: 'Regional Surveys Division',
      email: 'r.garises@murdh.gov.na'
    },
    assignedBy: { name: 'Mr. F. Nghidishange', role: 'Executive Director', ministry: 'MURDH' },
    assignedDate: '2025-03-25',
    status: 'In Progress',
    priority: 'high',
    progress: 60,
    startDate: '2025-04-01',
    deadline: '2025-06-15',
    completedDate: null,
    checklistItems: [
      { id: 'CK-05', item: 'Obtain aerial survey data for Erongo', completed: true },
      { id: 'CK-06', item: 'Conduct on-site assessment in Walvis Bay', completed: true },
      { id: 'CK-07', item: 'Conduct on-site assessment in Swakopmund', completed: false },
      { id: 'CK-08', item: 'Prepare consolidated survey report', completed: false }
    ],
    evidenceAttachments: [
      { name: 'ERONGO_AERIAL_DATA.pdf', uploadedAt: '2025-04-10T08:00:00Z', type: 'application/pdf' }
    ],
    notes: 'Walvis Bay parcels surveyed. Swakopmund assessment scheduled for next week.',
    comments: [
      { id: 'CMT-003', author: 'Ms. R. Garises', date: '2025-05-20T11:00:00Z', text: 'Walvis Bay assessment complete. Two viable sites identified near Kuisebmond.' }
    ],
    lastUpdated: '2025-05-20T11:30:00Z'
  },
  {
    id: 'ASG-001-01-C',
    parentDirectiveId: 'DIR-2025-001-01',
    parentDecisionId: 'CAB-2025-001',
    taskDescription: 'Complete land survey and identification in Oshana Region',
    assignedTo: {
      name: 'Mr. P. Shilongo',
      role: 'Regional Land Surveyor',
      title: 'Senior Officer: Land Use Planning',
      ministry: 'MURDH',
      directorate: 'Land Use Planning Directorate',
      division: 'Northern Regions Division',
      email: 'p.shilongo@murdh.gov.na'
    },
    assignedBy: { name: 'Mr. F. Nghidishange', role: 'Executive Director', ministry: 'MURDH' },
    assignedDate: '2025-03-25',
    status: 'In Progress',
    priority: 'medium',
    progress: 30,
    startDate: '2025-04-15',
    deadline: '2025-06-30',
    completedDate: null,
    checklistItems: [
      { id: 'CK-09', item: 'Obtain aerial survey data for Oshana', completed: true },
      { id: 'CK-10', item: 'Conduct on-site assessment in Oshakati', completed: false },
      { id: 'CK-11', item: 'Prepare survey report', completed: false }
    ],
    evidenceAttachments: [],
    notes: 'Aerial data received. On-site assessment pending travel arrangements.',
    comments: [],
    lastUpdated: '2025-05-01T09:00:00Z'
  },

  // === Assignments for DIR-2025-001-02 (Housing bulk infrastructure) ===
  {
    id: 'ASG-001-02-A',
    parentDirectiveId: 'DIR-2025-001-02',
    parentDecisionId: 'CAB-2025-001',
    taskDescription: 'Design bulk water and sewer reticulation for Windhoek Mass Housing site',
    assignedTo: {
      name: 'Mr. J. Hamutenya',
      role: 'Civil Engineer',
      title: 'Director: Infrastructure Planning',
      ministry: 'MWTI',
      directorate: 'Infrastructure Planning Directorate',
      division: 'Water & Sanitation Division',
      email: 'j.hamutenya@mwti.gov.na'
    },
    assignedBy: { name: 'Ms. A. Nghifindaka', role: 'Executive Director', ministry: 'MWTI' },
    assignedDate: '2025-04-01',
    status: 'In Progress',
    priority: 'high',
    progress: 40,
    startDate: '2025-04-10',
    deadline: '2025-09-30',
    completedDate: null,
    checklistItems: [
      { id: 'CK-12', item: 'Topographic survey of housing site', completed: true },
      { id: 'CK-13', item: 'Demand assessment for 5 000 units', completed: true },
      { id: 'CK-14', item: 'Preliminary engineering design', completed: false },
      { id: 'CK-15', item: 'Environmental clearance application', completed: false },
      { id: 'CK-16', item: 'Finalise Bill of Quantities', completed: false }
    ],
    evidenceAttachments: [
      { name: 'TOPO_SURVEY_WHK_MASS_HOUSING.pdf', uploadedAt: '2025-04-25T09:00:00Z', type: 'application/pdf' }
    ],
    notes: 'Topographic survey done. Demand assessment confirms 5 000 unit requirement.',
    comments: [],
    lastUpdated: '2025-06-01T10:00:00Z'
  },

  // === Assignments for DIR-2025-002-01 (Drought early-warning) ===
  {
    id: 'ASG-002-01-A',
    parentDirectiveId: 'DIR-2025-002-01',
    parentDecisionId: 'CAB-2025-002',
    taskDescription: 'Establish real-time water-level monitoring at 15 critical boreholes in Kunene',
    assignedTo: {
      name: 'Ms. E. Tjirera',
      role: 'Hydrologist',
      title: 'Deputy Director: Water Resources',
      ministry: 'MAFWLR',
      directorate: 'Water Resources Management Directorate',
      division: 'Hydrology Division',
      email: 'e.tjirera@mafwlr.gov.na'
    },
    assignedBy: { name: 'Mr. T. Ekandjo', role: 'Executive Director', ministry: 'MAFWLR' },
    assignedDate: '2025-02-20',
    status: 'Overdue',
    priority: 'critical',
    progress: 55,
    startDate: '2025-03-01',
    deadline: '2025-06-30',
    completedDate: null,
    checklistItems: [
      { id: 'CK-17', item: 'Procure 15 telemetric water-level sensors', completed: true },
      { id: 'CK-18', item: 'Install sensors at boreholes in Opuwo district', completed: true },
      { id: 'CK-19', item: 'Install sensors at boreholes in Khorixas district', completed: false },
      { id: 'CK-20', item: 'Connect sensors to national SCADA dashboard', completed: false }
    ],
    evidenceAttachments: [
      { name: 'SENSOR_PROCUREMENT_PO.pdf', uploadedAt: '2025-03-10T08:00:00Z', type: 'application/pdf' }
    ],
    notes: 'Opuwo installations complete. Khorixas delayed due to road access after flooding.',
    comments: [
      { id: 'CMT-004', author: 'Ms. E. Tjirera', date: '2025-06-15T10:00:00Z', text: 'Khorixas access roads washed out. Requested MWT emergency grading.' }
    ],
    lastUpdated: '2025-07-01T08:00:00Z'
  },
  {
    id: 'ASG-002-01-B',
    parentDirectiveId: 'DIR-2025-002-01',
    parentDecisionId: 'CAB-2025-002',
    taskDescription: 'Develop drought severity classification model using historical rainfall data',
    assignedTo: {
      name: 'Dr. M. Shikongo',
      role: 'Climate Scientist',
      title: 'Director: Climate Services',
      ministry: 'MEFT',
      directorate: 'Meteorological Services Directorate',
      division: 'Climate Analysis Division',
      email: 'm.shikongo@meft.gov.na'
    },
    assignedBy: { name: 'Mr. T. Ekandjo', role: 'Executive Director', ministry: 'MAFWLR' },
    assignedDate: '2025-02-20',
    status: 'Completed',
    priority: 'high',
    progress: 100,
    startDate: '2025-03-01',
    deadline: '2025-05-31',
    completedDate: '2025-05-18',
    checklistItems: [
      { id: 'CK-21', item: 'Compile 30-year rainfall dataset for all 14 regions', completed: true },
      { id: 'CK-22', item: 'Define 5-level drought severity index', completed: true },
      { id: 'CK-23', item: 'Validate model against 2019 and 2013 drought events', completed: true },
      { id: 'CK-24', item: 'Present findings to inter-ministerial committee', completed: true }
    ],
    evidenceAttachments: [
      { name: 'DROUGHT_SEVERITY_MODEL_v2.pdf', uploadedAt: '2025-05-15T14:00:00Z', type: 'application/pdf' },
      { name: 'VALIDATION_RESULTS.xlsx', uploadedAt: '2025-05-15T14:05:00Z', type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
    ],
    notes: 'Model validated with 91% accuracy against historical events.',
    comments: [
      { id: 'CMT-005', author: 'Dr. M. Shikongo', date: '2025-05-18T09:00:00Z', text: 'Final model delivered. Recommended for adoption by MAFWLR and OPM.' }
    ],
    lastUpdated: '2025-05-18T10:00:00Z'
  },

  // === Assignments for DIR-2025-002-02 (Emergency fodder distribution) ===
  {
    id: 'ASG-002-02-A',
    parentDirectiveId: 'DIR-2025-002-02',
    parentDecisionId: 'CAB-2025-002',
    taskDescription: 'Coordinate emergency fodder procurement and logistics for Kunene and Omaheke',
    assignedTo: {
      name: 'Mr. N. Kapia',
      role: 'Procurement Officer',
      title: 'Deputy Director: Agricultural Inputs',
      ministry: 'MAFWLR',
      directorate: 'Agricultural Production Directorate',
      division: 'Inputs & Livestock Division',
      email: 'n.kapia@mafwlr.gov.na'
    },
    assignedBy: { name: 'Mr. T. Ekandjo', role: 'Executive Director', ministry: 'MAFWLR' },
    assignedDate: '2025-02-18',
    status: 'Completed',
    priority: 'critical',
    progress: 100,
    startDate: '2025-02-20',
    deadline: '2025-04-30',
    completedDate: '2025-04-22',
    checklistItems: [
      { id: 'CK-25', item: 'Issue emergency procurement tender', completed: true },
      { id: 'CK-26', item: 'Award contract to qualifying supplier', completed: true },
      { id: 'CK-27', item: 'Deliver 2 000 tonnes of fodder to distribution points', completed: true },
      { id: 'CK-28', item: 'Submit delivery confirmation to ED', completed: true }
    ],
    evidenceAttachments: [
      { name: 'FODDER_TENDER_AWARD.pdf', uploadedAt: '2025-03-05T09:00:00Z', type: 'application/pdf' },
      { name: 'DELIVERY_NOTES_KUNENE.pdf', uploadedAt: '2025-04-20T16:00:00Z', type: 'application/pdf' }
    ],
    notes: '2 000 tonnes delivered across 12 distribution points in Kunene and Omaheke.',
    comments: [],
    lastUpdated: '2025-04-22T12:00:00Z'
  },

  // === Assignments for DIR-2025-003-01 (e-Cabinet platform) ===
  {
    id: 'ASG-003-01-A',
    parentDirectiveId: 'DIR-2025-003-01',
    parentDecisionId: 'CAB-2025-003',
    taskDescription: 'Develop requirements specification for e-Cabinet memorandum submission portal',
    assignedTo: {
      name: 'Ms. L. Nakamwe',
      role: 'Systems Analyst',
      title: 'Director: e-Government Services',
      ministry: 'MICT',
      directorate: 'e-Government Directorate',
      division: 'Systems Development Division',
      email: 'l.nakamwe@mict.gov.na'
    },
    assignedBy: { name: 'Mr. G. Simataa', role: 'Executive Director', ministry: 'MICT' },
    assignedDate: '2025-05-05',
    status: 'Completed',
    priority: 'high',
    progress: 100,
    startDate: '2025-05-10',
    deadline: '2025-07-15',
    completedDate: '2025-07-08',
    checklistItems: [
      { id: 'CK-29', item: 'Conduct stakeholder workshops with all 14 ministries', completed: true },
      { id: 'CK-30', item: 'Document functional requirements', completed: true },
      { id: 'CK-31', item: 'Document non-functional requirements (security, availability)', completed: true },
      { id: 'CK-32', item: 'Obtain sign-off from Secretary to Cabinet', completed: true }
    ],
    evidenceAttachments: [
      { name: 'E_CABINET_REQUIREMENTS_v1.pdf', uploadedAt: '2025-07-05T10:00:00Z', type: 'application/pdf' }
    ],
    notes: 'Requirements signed off. Recommended cloud-first approach with NIPDB data sovereignty compliance.',
    comments: [],
    lastUpdated: '2025-07-08T14:00:00Z'
  },
  {
    id: 'ASG-003-01-B',
    parentDirectiveId: 'DIR-2025-003-01',
    parentDecisionId: 'CAB-2025-003',
    taskDescription: 'Procure development vendor for e-Cabinet platform via competitive bidding',
    assignedTo: {
      name: 'Mr. S. Amukoto',
      role: 'Procurement Specialist',
      title: 'Deputy Director: ICT Procurement',
      ministry: 'MICT',
      directorate: 'e-Government Directorate',
      division: 'ICT Procurement Division',
      email: 's.amukoto@mict.gov.na'
    },
    assignedBy: { name: 'Mr. G. Simataa', role: 'Executive Director', ministry: 'MICT' },
    assignedDate: '2025-07-10',
    status: 'In Progress',
    priority: 'high',
    progress: 35,
    startDate: '2025-07-15',
    deadline: '2025-11-30',
    completedDate: null,
    checklistItems: [
      { id: 'CK-33', item: 'Draft tender document (RFP)', completed: true },
      { id: 'CK-34', item: 'Obtain CPBN approval for tender', completed: true },
      { id: 'CK-35', item: 'Publish tender in Government Gazette', completed: false },
      { id: 'CK-36', item: 'Evaluate bids and award contract', completed: false }
    ],
    evidenceAttachments: [
      { name: 'E_CABINET_RFP_DRAFT.pdf', uploadedAt: '2025-08-01T09:00:00Z', type: 'application/pdf' }
    ],
    notes: 'RFP drafted. Awaiting CPBN final approval before Gazette publication.',
    comments: [],
    lastUpdated: '2025-09-15T10:00:00Z'
  },

  // === Assignments for DIR-2025-003-02 (Cybersecurity framework) ===
  {
    id: 'ASG-003-02-A',
    parentDirectiveId: 'DIR-2025-003-02',
    parentDecisionId: 'CAB-2025-003',
    taskDescription: 'Draft Government Information Security Policy aligned to ISO 27001',
    assignedTo: {
      name: 'Mr. H. Angula',
      role: 'Information Security Officer',
      title: 'Director: Cybersecurity',
      ministry: 'MICT',
      directorate: 'Cybersecurity Directorate',
      division: 'Policy & Standards Division',
      email: 'h.angula@mict.gov.na'
    },
    assignedBy: { name: 'Mr. G. Simataa', role: 'Executive Director', ministry: 'MICT' },
    assignedDate: '2025-05-05',
    status: 'In Progress',
    priority: 'medium',
    progress: 70,
    startDate: '2025-05-15',
    deadline: '2025-12-31',
    completedDate: null,
    checklistItems: [
      { id: 'CK-37', item: 'Benchmark against SADC member state policies', completed: true },
      { id: 'CK-38', item: 'Draft policy document', completed: true },
      { id: 'CK-39', item: 'Circulate for inter-ministerial comment', completed: true },
      { id: 'CK-40', item: 'Incorporate feedback and finalise', completed: false },
      { id: 'CK-41', item: 'Submit to Cabinet for endorsement', completed: false }
    ],
    evidenceAttachments: [
      { name: 'GOV_INFOSEC_POLICY_DRAFT_v3.pdf', uploadedAt: '2025-09-01T10:00:00Z', type: 'application/pdf' }
    ],
    notes: 'Draft v3 circulated. MHAISS and MODVA provided substantive comments on classification levels.',
    comments: [],
    lastUpdated: '2025-10-01T09:00:00Z'
  },

  // === Assignments for DIR-2025-004-01 (Procurement reform bill) ===
  {
    id: 'ASG-004-01-A',
    parentDirectiveId: 'DIR-2025-004-01',
    parentDecisionId: 'CAB-2025-004',
    taskDescription: 'Finalise drafting of Public Procurement Amendment Bill provisions on e-procurement',
    assignedTo: {
      name: 'Adv. M. Nakandjembo',
      role: 'Legislative Drafter',
      title: 'Director: Legislative Drafting',
      ministry: 'MJL',
      directorate: 'Legislative Drafting Directorate',
      division: 'Commercial Law Division',
      email: 'm.nakandjembo@mjl.gov.na'
    },
    assignedBy: { name: 'Adv. S. Kauluma', role: 'Executive Director', ministry: 'MJL' },
    assignedDate: '2025-01-20',
    status: 'Overdue',
    priority: 'high',
    progress: 60,
    startDate: '2025-02-01',
    deadline: '2025-06-30',
    completedDate: null,
    checklistItems: [
      { id: 'CK-42', item: 'Review comparative legislation (SA, Botswana, Kenya)', completed: true },
      { id: 'CK-43', item: 'Draft e-procurement provisions', completed: true },
      { id: 'CK-44', item: 'Draft local content and SME preference provisions', completed: true },
      { id: 'CK-45', item: 'Legal review by Attorney General', completed: false },
      { id: 'CK-46', item: 'Stakeholder consultation (NCCI, private sector)', completed: false }
    ],
    evidenceAttachments: [
      { name: 'PROCUREMENT_BILL_DRAFT_v2.pdf', uploadedAt: '2025-05-20T10:00:00Z', type: 'application/pdf' }
    ],
    notes: 'Draft provisions completed but AG review delayed due to competing priorities.',
    comments: [
      { id: 'CMT-006', author: 'Adv. M. Nakandjembo', date: '2025-07-10T09:00:00Z', text: 'AG office has assigned reviewer. Expected turnaround 3 weeks.' }
    ],
    lastUpdated: '2025-08-01T10:00:00Z'
  },
  {
    id: 'ASG-004-01-B',
    parentDirectiveId: 'DIR-2025-004-01',
    parentDecisionId: 'CAB-2025-004',
    taskDescription: 'Compile regulatory impact assessment for Procurement Amendment Bill',
    assignedTo: {
      name: 'Ms. T. Kanime',
      role: 'Policy Analyst',
      title: 'Deputy Director: Policy Research',
      ministry: 'MFSGM',
      directorate: 'Policy & Research Directorate',
      division: 'Economic Analysis Division',
      email: 't.kanime@mfsgm.gov.na'
    },
    assignedBy: { name: 'Adv. S. Kauluma', role: 'Executive Director', ministry: 'MJL' },
    assignedDate: '2025-01-20',
    status: 'Blocked',
    priority: 'medium',
    progress: 20,
    startDate: '2025-02-15',
    deadline: '2025-08-31',
    completedDate: null,
    checklistItems: [
      { id: 'CK-47', item: 'Gather procurement spend data from CPBN for FY2022-2024', completed: true },
      { id: 'CK-48', item: 'Model cost-benefit of e-procurement adoption', completed: false },
      { id: 'CK-49', item: 'Assess impact on SME participation rates', completed: false },
      { id: 'CK-50', item: 'Draft RIA report', completed: false }
    ],
    evidenceAttachments: [],
    notes: 'Blocked pending finalisation of Bill provisions (ASG-004-01-A) to scope the RIA correctly.',
    comments: [],
    lastUpdated: '2025-06-15T09:00:00Z'
  },

  // === Assignments for DIR-2025-005-01 (School feeding expansion) ===
  {
    id: 'ASG-005-01-A',
    parentDirectiveId: 'DIR-2025-005-01',
    parentDecisionId: 'CAB-2025-005',
    taskDescription: 'Map all schools without feeding programmes in Kavango East and Zambezi',
    assignedTo: {
      name: 'Ms. N. Haimbodi',
      role: 'Education Planner',
      title: 'Deputy Director: School Nutrition',
      ministry: 'MEIYSC',
      directorate: 'Programmes & Quality Assurance Directorate',
      division: 'School Nutrition Division',
      email: 'n.haimbodi@meiysc.gov.na'
    },
    assignedBy: { name: 'Dr. A. Ilonga', role: 'Executive Director', ministry: 'MEIYSC' },
    assignedDate: '2024-09-10',
    status: 'Completed',
    priority: 'high',
    progress: 100,
    startDate: '2024-09-15',
    deadline: '2024-12-15',
    completedDate: '2024-12-02',
    checklistItems: [
      { id: 'CK-51', item: 'Obtain EMIS data on school enrolment and existing programmes', completed: true },
      { id: 'CK-52', item: 'Conduct regional verification visits', completed: true },
      { id: 'CK-53', item: 'Compile gap analysis report with cost estimates', completed: true }
    ],
    evidenceAttachments: [
      { name: 'SCHOOL_FEEDING_GAP_ANALYSIS.pdf', uploadedAt: '2024-12-01T10:00:00Z', type: 'application/pdf' }
    ],
    notes: '147 schools identified without feeding programmes. Estimated cost: N$42M per annum.',
    comments: [],
    lastUpdated: '2024-12-02T14:00:00Z'
  },
  {
    id: 'ASG-005-01-B',
    parentDirectiveId: 'DIR-2025-005-01',
    parentDecisionId: 'CAB-2025-005',
    taskDescription: 'Procure food suppliers for 80 priority schools in Kavango East',
    assignedTo: {
      name: 'Mr. V. Likuwa',
      role: 'Procurement Officer',
      title: 'Chief Officer: Procurement',
      ministry: 'MEIYSC',
      directorate: 'Administration Directorate',
      division: 'Procurement Division',
      email: 'v.likuwa@meiysc.gov.na'
    },
    assignedBy: { name: 'Dr. A. Ilonga', role: 'Executive Director', ministry: 'MEIYSC' },
    assignedDate: '2024-12-10',
    status: 'Completed',
    priority: 'high',
    progress: 100,
    startDate: '2024-12-15',
    deadline: '2025-03-31',
    completedDate: '2025-03-20',
    checklistItems: [
      { id: 'CK-54', item: 'Draft tender specifications for school feeding supplies', completed: true },
      { id: 'CK-55', item: 'Advertise and evaluate bids', completed: true },
      { id: 'CK-56', item: 'Award contracts to qualifying local suppliers', completed: true },
      { id: 'CK-57', item: 'Confirm delivery schedules for Term 2 2025', completed: true }
    ],
    evidenceAttachments: [
      { name: 'FEEDING_TENDER_AWARDS.pdf', uploadedAt: '2025-03-18T09:00:00Z', type: 'application/pdf' }
    ],
    notes: 'Contracts awarded to 5 local suppliers. Deliveries confirmed for April 2025.',
    comments: [],
    lastUpdated: '2025-03-20T16:00:00Z'
  },

  // === Assignments for DIR-2025-005-02 (Nutrition monitoring) ===
  {
    id: 'ASG-005-02-A',
    parentDirectiveId: 'DIR-2025-005-02',
    parentDecisionId: 'CAB-2025-005',
    taskDescription: 'Develop school nutrition monitoring and reporting framework',
    assignedTo: {
      name: 'Dr. S. Amakali',
      role: 'Nutritionist',
      title: 'Director: Nutrition Services',
      ministry: 'MHSS',
      directorate: 'Primary Health Care Directorate',
      division: 'Nutrition Division',
      email: 's.amakali@mhss.gov.na'
    },
    assignedBy: { name: 'Dr. A. Ilonga', role: 'Executive Director', ministry: 'MEIYSC' },
    assignedDate: '2024-09-15',
    status: 'Completed',
    priority: 'medium',
    progress: 100,
    startDate: '2024-10-01',
    deadline: '2025-02-28',
    completedDate: '2025-02-20',
    checklistItems: [
      { id: 'CK-58', item: 'Define nutritional standards for school meals', completed: true },
      { id: 'CK-59', item: 'Design monitoring data collection tools', completed: true },
      { id: 'CK-60', item: 'Train 50 regional education officers on monitoring', completed: true }
    ],
    evidenceAttachments: [
      { name: 'NUTRITION_MONITORING_FRAMEWORK.pdf', uploadedAt: '2025-02-18T10:00:00Z', type: 'application/pdf' }
    ],
    notes: 'Framework adopted. Training completed in all northern regions.',
    comments: [],
    lastUpdated: '2025-02-20T12:00:00Z'
  },

  // === Assignments for DIR-2025-006-01 (Green Scheme irrigation review) ===
  {
    id: 'ASG-006-01-A',
    parentDirectiveId: 'DIR-2025-006-01',
    parentDecisionId: 'CAB-2025-006',
    taskDescription: 'Conduct value-for-money audit of Green Scheme irrigation projects 2020-2024',
    assignedTo: {
      name: 'Mr. B. Hangula',
      role: 'Senior Auditor',
      title: 'Director: Performance Audit',
      ministry: 'MFSGM',
      directorate: 'Internal Audit Directorate',
      division: 'Performance Audit Division',
      email: 'b.hangula@mfsgm.gov.na'
    },
    assignedBy: { name: 'Mr. T. Ekandjo', role: 'Executive Director', ministry: 'MAFWLR' },
    assignedDate: '2025-08-20',
    status: 'Pending',
    priority: 'high',
    progress: 0,
    startDate: null,
    deadline: '2025-12-31',
    completedDate: null,
    checklistItems: [
      { id: 'CK-61', item: 'Obtain expenditure records for all Green Scheme projects', completed: false },
      { id: 'CK-62', item: 'Conduct site visits to 5 irrigation schemes', completed: false },
      { id: 'CK-63', item: 'Prepare audit findings report', completed: false }
    ],
    evidenceAttachments: [],
    notes: 'Awaiting commencement. Audit terms of reference under development.',
    comments: [],
    lastUpdated: '2025-08-20T09:00:00Z'
  },

  // === Assignments for DIR-2025-007-01 (Renewable energy procurement) ===
  {
    id: 'ASG-007-01-A',
    parentDirectiveId: 'DIR-2025-007-01',
    parentDecisionId: 'CAB-2025-007',
    taskDescription: 'Draft modified single-buyer model framework for renewable IPPs',
    assignedTo: {
      name: 'Mr. I. Nashandi',
      role: 'Energy Economist',
      title: 'Director: Energy Policy',
      ministry: 'MIME',
      directorate: 'Energy Directorate',
      division: 'Policy & Planning Division',
      email: 'i.nashandi@mime.gov.na'
    },
    assignedBy: { name: 'Ms. K. Hanse-Himarwa', role: 'Executive Director', ministry: 'MIME' },
    assignedDate: '2025-10-10',
    status: 'Pending',
    priority: 'high',
    progress: 0,
    startDate: null,
    deadline: '2026-04-30',
    completedDate: null,
    checklistItems: [
      { id: 'CK-64', item: 'Review regional IPP frameworks (SA REIPPP, Kenya FiT)', completed: false },
      { id: 'CK-65', item: 'Draft framework document', completed: false },
      { id: 'CK-66', item: 'Consult with NamPower and ECB', completed: false },
      { id: 'CK-67', item: 'Submit to ED for inter-ministerial circulation', completed: false }
    ],
    evidenceAttachments: [],
    notes: 'Pending commencement. ED has prioritised this for Q1 2026.',
    comments: [],
    lastUpdated: '2025-10-10T10:00:00Z'
  },
  {
    id: 'ASG-007-01-B',
    parentDirectiveId: 'DIR-2025-007-01',
    parentDecisionId: 'CAB-2025-007',
    taskDescription: 'Assess grid capacity for 200MW additional renewable generation in central corridor',
    assignedTo: {
      name: 'Ms. D. Garoes',
      role: 'Electrical Engineer',
      title: 'Deputy Director: Grid Planning',
      ministry: 'MIME',
      directorate: 'Energy Directorate',
      division: 'Grid Infrastructure Division',
      email: 'd.garoes@mime.gov.na'
    },
    assignedBy: { name: 'Ms. K. Hanse-Himarwa', role: 'Executive Director', ministry: 'MIME' },
    assignedDate: '2025-10-10',
    status: 'Pending',
    priority: 'medium',
    progress: 0,
    startDate: null,
    deadline: '2026-03-31',
    completedDate: null,
    checklistItems: [
      { id: 'CK-68', item: 'Obtain current grid load data from NamPower', completed: false },
      { id: 'CK-69', item: 'Model grid stability with 200MW additional renewable capacity', completed: false },
      { id: 'CK-70', item: 'Identify required transmission upgrades', completed: false }
    ],
    evidenceAttachments: [],
    notes: 'Pending commencement.',
    comments: [],
    lastUpdated: '2025-10-10T10:00:00Z'
  },

  // === Assignments for DIR-2025-007-02 (MEFT environmental fast-track) ===
  {
    id: 'ASG-007-02-A',
    parentDirectiveId: 'DIR-2025-007-02',
    parentDecisionId: 'CAB-2025-007',
    taskDescription: 'Develop fast-track EIA guidelines for solar and wind projects under 50MW',
    assignedTo: {
      name: 'Ms. U. Katjivena',
      role: 'Environmental Assessment Officer',
      title: 'Deputy Director: Environmental Assessment',
      ministry: 'MEFT',
      directorate: 'Environmental Affairs Directorate',
      division: 'Environmental Assessment Division',
      email: 'u.katjivena@meft.gov.na'
    },
    assignedBy: { name: 'Mr. T. Nghitila', role: 'Executive Director', ministry: 'MEFT' },
    assignedDate: '2025-10-15',
    status: 'Pending',
    priority: 'medium',
    progress: 0,
    startDate: null,
    deadline: '2026-06-30',
    completedDate: null,
    checklistItems: [
      { id: 'CK-71', item: 'Review current EIA timelines and bottlenecks', completed: false },
      { id: 'CK-72', item: 'Draft fast-track screening criteria', completed: false },
      { id: 'CK-73', item: 'Consult with renewable energy developers', completed: false },
      { id: 'CK-74', item: 'Publish draft guidelines for public comment', completed: false }
    ],
    evidenceAttachments: [],
    notes: 'Pending commencement.',
    comments: [],
    lastUpdated: '2025-10-15T09:00:00Z'
  }
];

// ---------------------------------------------------------------------------
// 3.3  Directives
// ---------------------------------------------------------------------------
const directives = [
  // === Decision CAB-2025-001: Housing Programme (In Progress) — 2 directives ===
  {
    id: 'DIR-2025-001-01',
    parentDecisionId: 'CAB-2025-001',
    sequenceNumber: 1,
    title: 'Identify and allocate serviced land in all 14 regions',
    description: 'Executive Directors must identify and gazette suitable land parcels for mass housing in each of the 14 regions, prioritising peri-urban areas with existing bulk infrastructure.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MURDH',
    assignedEntityName: 'Ministry of Urban & Rural Development, Housing',
    assigneeName: 'Mr. F. Nghidishange',
    assigneeRole: 'Executive Director',
    status: 'In Progress',
    priority: 'high',
    progress: 63,
    createdDate: '2025-03-20',
    startDate: '2025-03-20',
    deadline: '2025-06-30',
    extendedDeadline: null,
    extensionRequested: false,
    extensionApproved: false,
    milestones: [
      { id: 'MS-001', title: 'Working group establishment', deadline: '2025-03-31', status: 'Completed', completedDate: '2025-03-25' },
      { id: 'MS-002', title: 'Regional land surveys', deadline: '2025-05-15', status: 'In Progress', completedDate: null },
      { id: 'MS-003', title: 'Gazette publication', deadline: '2025-06-15', status: 'Pending', completedDate: null },
      { id: 'MS-004', title: 'Final allocation report', deadline: '2025-06-30', status: 'Pending', completedDate: null }
    ],
    assignmentIds: ['ASG-001-01-A', 'ASG-001-01-B', 'ASG-001-01-C'],
    totalAssignments: 3,
    completedAssignments: 1,
    evidence: [
      { id: 'EVD-001', title: 'Working Group Terms of Reference', type: 'DOCUMENT', fileType: 'pdf', uploadedBy: 'ED MURDH', uploadedDate: '2025-03-26', verifiedBy: null, verifiedDate: null }
    ],
    lastReportDate: '2025-06-01',
    nextReportDue: '2025-09-01',
    lastUpdated: '2025-06-10T09:00:00Z'
  },
  {
    id: 'DIR-2025-001-02',
    parentDecisionId: 'CAB-2025-001',
    sequenceNumber: 2,
    title: 'Design and cost bulk infrastructure for priority housing sites',
    description: 'MWTI to design bulk water, sewer, and road infrastructure for the first tranche of 5 000 housing units in Windhoek, Walvis Bay, and Oshakati.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MWTI',
    assignedEntityName: 'Ministry of Works, Transport & Infrastructure',
    assigneeName: 'Ms. A. Nghifindaka',
    assigneeRole: 'Executive Director',
    status: 'In Progress',
    priority: 'high',
    progress: 40,
    createdDate: '2025-03-20',
    startDate: '2025-04-01',
    deadline: '2025-09-30',
    extendedDeadline: null,
    extensionRequested: false,
    extensionApproved: false,
    milestones: [
      { id: 'MS-005', title: 'Topographic surveys completed', deadline: '2025-04-30', status: 'Completed', completedDate: '2025-04-25' },
      { id: 'MS-006', title: 'Preliminary engineering designs', deadline: '2025-07-15', status: 'In Progress', completedDate: null },
      { id: 'MS-007', title: 'Environmental clearances obtained', deadline: '2025-08-31', status: 'Pending', completedDate: null },
      { id: 'MS-008', title: 'Final costed designs submitted', deadline: '2025-09-30', status: 'Pending', completedDate: null }
    ],
    assignmentIds: ['ASG-001-02-A'],
    totalAssignments: 1,
    completedAssignments: 0,
    evidence: [],
    lastReportDate: '2025-06-01',
    nextReportDue: '2025-09-01',
    lastUpdated: '2025-06-01T10:00:00Z'
  },

  // === Decision CAB-2025-002: Drought Response (Overdue) — 2 directives ===
  {
    id: 'DIR-2025-002-01',
    parentDecisionId: 'CAB-2025-002',
    sequenceNumber: 1,
    title: 'Establish drought early-warning monitoring system for arid regions',
    description: 'MAFWLR and MEFT to jointly establish a real-time drought monitoring system covering Kunene, Erongo, Hardap, and Karas regions using borehole telemetry and satellite data.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MAFWLR',
    assignedEntityName: 'Ministry of Agriculture, Fisheries, Water & Land Reform',
    assigneeName: 'Mr. T. Ekandjo',
    assigneeRole: 'Executive Director',
    status: 'Overdue',
    priority: 'critical',
    progress: 55,
    createdDate: '2025-02-17',
    startDate: '2025-03-01',
    deadline: '2025-06-30',
    extendedDeadline: '2025-09-30',
    extensionRequested: true,
    extensionApproved: true,
    milestones: [
      { id: 'MS-009', title: 'Sensor procurement completed', deadline: '2025-03-31', status: 'Completed', completedDate: '2025-03-28' },
      { id: 'MS-010', title: 'Opuwo installations complete', deadline: '2025-04-30', status: 'Completed', completedDate: '2025-05-05' },
      { id: 'MS-011', title: 'Khorixas installations complete', deadline: '2025-05-31', status: 'Overdue', completedDate: null },
      { id: 'MS-012', title: 'SCADA dashboard integration', deadline: '2025-06-30', status: 'Pending', completedDate: null }
    ],
    assignmentIds: ['ASG-002-01-A', 'ASG-002-01-B'],
    totalAssignments: 2,
    completedAssignments: 1,
    evidence: [
      { id: 'EVD-002', title: 'Drought Severity Classification Model', type: 'REPORT', fileType: 'pdf', uploadedBy: 'Dr. M. Shikongo', uploadedDate: '2025-05-15', verifiedBy: 'ED MAFWLR', verifiedDate: '2025-05-20' }
    ],
    lastReportDate: '2025-06-01',
    nextReportDue: '2025-09-01',
    lastUpdated: '2025-07-01T08:00:00Z'
  },
  {
    id: 'DIR-2025-002-02',
    parentDecisionId: 'CAB-2025-002',
    sequenceNumber: 2,
    title: 'Coordinate emergency fodder and water distribution to affected areas',
    description: 'MAFWLR to immediately procure and distribute emergency livestock fodder and potable water to drought-affected communities in Kunene and Omaheke regions.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MAFWLR',
    assignedEntityName: 'Ministry of Agriculture, Fisheries, Water & Land Reform',
    assigneeName: 'Mr. T. Ekandjo',
    assigneeRole: 'Executive Director',
    status: 'Completed',
    priority: 'critical',
    progress: 100,
    createdDate: '2025-02-17',
    startDate: '2025-02-20',
    deadline: '2025-04-30',
    extendedDeadline: null,
    extensionRequested: false,
    extensionApproved: false,
    milestones: [
      { id: 'MS-013', title: 'Emergency tender issued', deadline: '2025-02-28', status: 'Completed', completedDate: '2025-02-25' },
      { id: 'MS-014', title: 'Fodder delivered to distribution points', deadline: '2025-04-15', status: 'Completed', completedDate: '2025-04-10' },
      { id: 'MS-015', title: 'Distribution confirmation report', deadline: '2025-04-30', status: 'Completed', completedDate: '2025-04-22' }
    ],
    assignmentIds: ['ASG-002-02-A'],
    totalAssignments: 1,
    completedAssignments: 1,
    evidence: [
      { id: 'EVD-003', title: 'Fodder Distribution Completion Report', type: 'REPORT', fileType: 'pdf', uploadedBy: 'ED MAFWLR', uploadedDate: '2025-04-23', verifiedBy: 'OPM Monitoring', verifiedDate: '2025-04-25' }
    ],
    lastReportDate: '2025-04-25',
    nextReportDue: null,
    lastUpdated: '2025-04-25T10:00:00Z'
  },

  // === Decision CAB-2025-003: Digital Government (In Progress) — 2 directives ===
  {
    id: 'DIR-2025-003-01',
    parentDecisionId: 'CAB-2025-003',
    sequenceNumber: 1,
    title: 'Develop and deploy e-Cabinet memorandum submission platform',
    description: 'MICT to lead the development of an electronic Cabinet memorandum submission and tracking system, replacing the current paper-based process.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MICT',
    assignedEntityName: 'Ministry of Information & Communication Technology',
    assigneeName: 'Mr. G. Simataa',
    assigneeRole: 'Executive Director',
    status: 'In Progress',
    priority: 'high',
    progress: 45,
    createdDate: '2025-05-01',
    startDate: '2025-05-10',
    deadline: '2026-03-31',
    extendedDeadline: null,
    extensionRequested: false,
    extensionApproved: false,
    milestones: [
      { id: 'MS-016', title: 'Requirements specification approved', deadline: '2025-07-15', status: 'Completed', completedDate: '2025-07-08' },
      { id: 'MS-017', title: 'Vendor procurement completed', deadline: '2025-11-30', status: 'In Progress', completedDate: null },
      { id: 'MS-018', title: 'Platform development and UAT', deadline: '2026-02-28', status: 'Pending', completedDate: null },
      { id: 'MS-019', title: 'Go-live and ministry onboarding', deadline: '2026-03-31', status: 'Pending', completedDate: null }
    ],
    assignmentIds: ['ASG-003-01-A', 'ASG-003-01-B'],
    totalAssignments: 2,
    completedAssignments: 1,
    evidence: [
      { id: 'EVD-004', title: 'e-Cabinet Requirements Specification v1', type: 'DOCUMENT', fileType: 'pdf', uploadedBy: 'Dir. e-Gov MICT', uploadedDate: '2025-07-05', verifiedBy: 'Secretary to Cabinet', verifiedDate: '2025-07-10' }
    ],
    lastReportDate: '2025-09-01',
    nextReportDue: '2025-12-01',
    lastUpdated: '2025-09-15T10:00:00Z'
  },
  {
    id: 'DIR-2025-003-02',
    parentDecisionId: 'CAB-2025-003',
    sequenceNumber: 2,
    title: 'Develop government-wide cybersecurity policy framework',
    description: 'MICT Cybersecurity Directorate to draft a comprehensive information security policy for all O/M/As, aligned with ISO 27001 and SADC cybersecurity frameworks.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MICT',
    assignedEntityName: 'Ministry of Information & Communication Technology',
    assigneeName: 'Mr. G. Simataa',
    assigneeRole: 'Executive Director',
    status: 'In Progress',
    priority: 'medium',
    progress: 70,
    createdDate: '2025-05-01',
    startDate: '2025-05-15',
    deadline: '2025-12-31',
    extendedDeadline: null,
    extensionRequested: false,
    extensionApproved: false,
    milestones: [
      { id: 'MS-020', title: 'SADC benchmarking complete', deadline: '2025-06-30', status: 'Completed', completedDate: '2025-06-20' },
      { id: 'MS-021', title: 'Draft policy circulated', deadline: '2025-08-31', status: 'Completed', completedDate: '2025-08-25' },
      { id: 'MS-022', title: 'Inter-ministerial comments incorporated', deadline: '2025-11-15', status: 'In Progress', completedDate: null },
      { id: 'MS-023', title: 'Cabinet endorsement submission', deadline: '2025-12-31', status: 'Pending', completedDate: null }
    ],
    assignmentIds: ['ASG-003-02-A'],
    totalAssignments: 1,
    completedAssignments: 0,
    evidence: [
      { id: 'EVD-005', title: 'Government InfoSec Policy Draft v3', type: 'DOCUMENT', fileType: 'pdf', uploadedBy: 'Dir. Cybersecurity MICT', uploadedDate: '2025-09-01', verifiedBy: null, verifiedDate: null }
    ],
    lastReportDate: '2025-09-01',
    nextReportDue: '2025-12-01',
    lastUpdated: '2025-10-01T09:00:00Z'
  },

  // === Decision CAB-2025-004: Procurement Reform (Stalled) — 1 directive ===
  {
    id: 'DIR-2025-004-01',
    parentDecisionId: 'CAB-2025-004',
    sequenceNumber: 1,
    title: 'Draft Public Procurement Amendment Bill for parliamentary tabling',
    description: 'MJL and MFSGM to jointly draft an amendment Bill introducing mandatory e-procurement, enhanced local content provisions, and SME preferential scoring.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MJL',
    assignedEntityName: 'Ministry of Justice & Labour Relations',
    assigneeName: 'Adv. S. Kauluma',
    assigneeRole: 'Executive Director',
    status: 'Overdue',
    priority: 'high',
    progress: 40,
    createdDate: '2025-01-18',
    startDate: '2025-02-01',
    deadline: '2025-06-30',
    extendedDeadline: '2025-09-30',
    extensionRequested: true,
    extensionApproved: false,
    milestones: [
      { id: 'MS-024', title: 'Comparative law review completed', deadline: '2025-03-15', status: 'Completed', completedDate: '2025-03-10' },
      { id: 'MS-025', title: 'Draft provisions finalised', deadline: '2025-05-15', status: 'Completed', completedDate: '2025-05-20' },
      { id: 'MS-026', title: 'AG legal review completed', deadline: '2025-06-15', status: 'Overdue', completedDate: null },
      { id: 'MS-027', title: 'Stakeholder consultation completed', deadline: '2025-06-30', status: 'Blocked', completedDate: null }
    ],
    assignmentIds: ['ASG-004-01-A', 'ASG-004-01-B'],
    totalAssignments: 2,
    completedAssignments: 0,
    evidence: [
      { id: 'EVD-006', title: 'Procurement Amendment Bill Draft v2', type: 'DOCUMENT', fileType: 'pdf', uploadedBy: 'Dir. Leg. Drafting MJL', uploadedDate: '2025-05-20', verifiedBy: null, verifiedDate: null }
    ],
    lastReportDate: '2025-06-01',
    nextReportDue: '2025-09-01',
    lastUpdated: '2025-08-01T10:00:00Z'
  },

  // === Decision CAB-2025-005: School Feeding (Completed) — 2 directives ===
  {
    id: 'DIR-2025-005-01',
    parentDecisionId: 'CAB-2025-005',
    sequenceNumber: 1,
    title: 'Expand school feeding programme to 147 uncovered schools in northern regions',
    description: 'MEIYSC to map, procure, and operationalise school feeding in all schools without programmes in Kavango East and Zambezi regions.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MEIYSC',
    assignedEntityName: 'Ministry of Education, Innovation, Youth, Sport, Arts & Culture',
    assigneeName: 'Dr. A. Ilonga',
    assigneeRole: 'Executive Director',
    status: 'Completed',
    priority: 'high',
    progress: 100,
    createdDate: '2024-09-05',
    startDate: '2024-09-15',
    deadline: '2025-03-31',
    extendedDeadline: null,
    extensionRequested: false,
    extensionApproved: false,
    milestones: [
      { id: 'MS-028', title: 'Gap analysis report completed', deadline: '2024-12-15', status: 'Completed', completedDate: '2024-12-02' },
      { id: 'MS-029', title: 'Supplier contracts awarded', deadline: '2025-03-15', status: 'Completed', completedDate: '2025-03-10' },
      { id: 'MS-030', title: 'Feeding programme operational in all 147 schools', deadline: '2025-03-31', status: 'Completed', completedDate: '2025-03-25' }
    ],
    assignmentIds: ['ASG-005-01-A', 'ASG-005-01-B'],
    totalAssignments: 2,
    completedAssignments: 2,
    evidence: [
      { id: 'EVD-007', title: 'Gap Analysis Report — School Feeding', type: 'REPORT', fileType: 'pdf', uploadedBy: 'DD School Nutrition MEIYSC', uploadedDate: '2024-12-01', verifiedBy: 'ED MEIYSC', verifiedDate: '2024-12-05' },
      { id: 'EVD-008', title: 'Programme Operationalisation Confirmation', type: 'REPORT', fileType: 'pdf', uploadedBy: 'ED MEIYSC', uploadedDate: '2025-03-25', verifiedBy: 'OPM Monitoring', verifiedDate: '2025-03-28' }
    ],
    lastReportDate: '2025-03-28',
    nextReportDue: null,
    lastUpdated: '2025-03-28T10:00:00Z'
  },
  {
    id: 'DIR-2025-005-02',
    parentDecisionId: 'CAB-2025-005',
    sequenceNumber: 2,
    title: 'Develop nutrition monitoring framework for school feeding programme',
    description: 'MHSS Nutrition Division to develop standardised nutrition monitoring tools and train regional education officers.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MHSS',
    assignedEntityName: 'Ministry of Health & Social Services',
    assigneeName: 'Dr. B. Katjirua',
    assigneeRole: 'Executive Director',
    status: 'Completed',
    priority: 'medium',
    progress: 100,
    createdDate: '2024-09-05',
    startDate: '2024-10-01',
    deadline: '2025-02-28',
    extendedDeadline: null,
    extensionRequested: false,
    extensionApproved: false,
    milestones: [
      { id: 'MS-031', title: 'Nutritional standards defined', deadline: '2024-11-30', status: 'Completed', completedDate: '2024-11-25' },
      { id: 'MS-032', title: 'Monitoring tools designed', deadline: '2025-01-15', status: 'Completed', completedDate: '2025-01-10' },
      { id: 'MS-033', title: 'Regional officers trained', deadline: '2025-02-28', status: 'Completed', completedDate: '2025-02-20' }
    ],
    assignmentIds: ['ASG-005-02-A'],
    totalAssignments: 1,
    completedAssignments: 1,
    evidence: [
      { id: 'EVD-009', title: 'Nutrition Monitoring Framework', type: 'DOCUMENT', fileType: 'pdf', uploadedBy: 'Dir. Nutrition MHSS', uploadedDate: '2025-02-18', verifiedBy: 'ED MHSS', verifiedDate: '2025-02-22' }
    ],
    lastReportDate: '2025-02-22',
    nextReportDue: null,
    lastUpdated: '2025-02-22T12:00:00Z'
  },

  // === Decision CAB-2025-006: Green Scheme Review (Pending) — 1 directive ===
  {
    id: 'DIR-2025-006-01',
    parentDecisionId: 'CAB-2025-006',
    sequenceNumber: 1,
    title: 'Conduct comprehensive review and audit of Green Scheme irrigation projects',
    description: 'MAFWLR and MFSGM to conduct a value-for-money audit and operational review of all Green Scheme projects from 2020 to 2024, with recommendations for NAM-2024-0882 continuation.',
    assignedEntityType: 'Committee',
    assignedEntityId: 'TC-GS-2025',
    assignedEntityName: 'Green Scheme Review Task Committee',
    assigneeName: 'Mr. T. Ekandjo',
    assigneeRole: 'Committee Chair (ED MAFWLR)',
    status: 'Pending',
    priority: 'high',
    progress: 0,
    createdDate: '2025-08-18',
    startDate: null,
    deadline: '2025-12-31',
    extendedDeadline: null,
    extensionRequested: false,
    extensionApproved: false,
    milestones: [
      { id: 'MS-034', title: 'Audit terms of reference approved', deadline: '2025-09-15', status: 'Pending', completedDate: null },
      { id: 'MS-035', title: 'Field audit visits completed', deadline: '2025-11-15', status: 'Pending', completedDate: null },
      { id: 'MS-036', title: 'Final report submitted to Cabinet', deadline: '2025-12-31', status: 'Pending', completedDate: null }
    ],
    assignmentIds: ['ASG-006-01-A'],
    totalAssignments: 1,
    completedAssignments: 0,
    evidence: [],
    lastReportDate: null,
    nextReportDue: '2025-09-30',
    lastUpdated: '2025-08-18T10:00:00Z'
  },

  // === Decision CAB-2025-007: Renewable Energy (Pending) — 2 directives ===
  {
    id: 'DIR-2025-007-01',
    parentDecisionId: 'CAB-2025-007',
    sequenceNumber: 1,
    title: 'Develop independent power producer framework for renewable energy',
    description: 'MIME to develop a modified single-buyer model framework enabling private renewable energy generation, including grid access rules, tariff methodology, and licensing procedures.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MIME',
    assignedEntityName: 'Ministry of Industrialisation, Mines & Energy',
    assigneeName: 'Ms. K. Hanse-Himarwa',
    assigneeRole: 'Executive Director',
    status: 'Pending',
    priority: 'high',
    progress: 0,
    createdDate: '2025-10-08',
    startDate: null,
    deadline: '2026-06-30',
    extendedDeadline: null,
    extensionRequested: false,
    extensionApproved: false,
    milestones: [
      { id: 'MS-037', title: 'Regional IPP framework review', deadline: '2026-01-31', status: 'Pending', completedDate: null },
      { id: 'MS-038', title: 'Draft framework document', deadline: '2026-03-31', status: 'Pending', completedDate: null },
      { id: 'MS-039', title: 'NamPower and ECB consultation', deadline: '2026-05-31', status: 'Pending', completedDate: null },
      { id: 'MS-040', title: 'Framework submitted to Cabinet', deadline: '2026-06-30', status: 'Pending', completedDate: null }
    ],
    assignmentIds: ['ASG-007-01-A', 'ASG-007-01-B'],
    totalAssignments: 2,
    completedAssignments: 0,
    evidence: [],
    lastReportDate: null,
    nextReportDue: '2026-01-15',
    lastUpdated: '2025-10-10T10:00:00Z'
  },
  {
    id: 'DIR-2025-007-02',
    parentDecisionId: 'CAB-2025-007',
    sequenceNumber: 2,
    title: 'Establish fast-track environmental clearance process for renewable projects',
    description: 'MEFT to develop expedited EIA guidelines for solar and wind projects under 50MW to reduce approval timelines from 18 months to 6 months.',
    assignedEntityType: 'Ministry',
    assignedEntityId: 'MEFT',
    assignedEntityName: 'Ministry of Environment, Forestry & Tourism',
    assigneeName: 'Mr. T. Nghitila',
    assigneeRole: 'Executive Director',
    status: 'Pending',
    priority: 'medium',
    progress: 0,
    createdDate: '2025-10-08',
    startDate: null,
    deadline: '2026-06-30',
    extendedDeadline: null,
    extensionRequested: false,
    extensionApproved: false,
    milestones: [
      { id: 'MS-041', title: 'Current EIA bottleneck analysis', deadline: '2026-01-15', status: 'Pending', completedDate: null },
      { id: 'MS-042', title: 'Draft fast-track guidelines', deadline: '2026-04-30', status: 'Pending', completedDate: null },
      { id: 'MS-043', title: 'Public comment period', deadline: '2026-06-15', status: 'Pending', completedDate: null }
    ],
    assignmentIds: ['ASG-007-02-A'],
    totalAssignments: 1,
    completedAssignments: 0,
    evidence: [],
    lastReportDate: null,
    nextReportDue: '2026-01-15',
    lastUpdated: '2025-10-15T09:00:00Z'
  }
];

// ---------------------------------------------------------------------------
// 3.2  Cabinet Decisions
// ---------------------------------------------------------------------------
const decisions = [
  // ── 1. POLICY / In Progress / NDP6 Pillar 2 ──
  {
    id: 'CAB-2025-001',
    referenceNumber: 'CAB/1/2025',
    cdn: '5TH/15.03.25/001',
    meetingId: 'CM-2025-05',
    title: 'National Housing Development Programme Acceleration',
    description: 'Cabinet resolved to accelerate the National Housing Programme to deliver 20 000 affordable housing units by 2028, prioritising Windhoek, Walvis Bay, and Oshakati. MURDH to lead with MWTI and MFSGM support.',
    fullText: 'Cabinet, having considered the memorandum from the Minister of Urban and Rural Development, Housing, and noting the acute housing backlog of 300 000 units nationally, resolves that: (1) The National Mass Housing Programme be accelerated to deliver 20 000 units by 2028; (2) MURDH shall identify and gazette serviced land in all 14 regions within 90 days; (3) MWTI shall design bulk infrastructure for priority sites; (4) MFSGM shall allocate N$2.5 billion over the MTEF period.',
    category: 'POLICY',
    priority: 'critical',
    classification: 'RESTRICTED',
    originatingMinistry: 'MURDH',
    originatingMinister: 'Hon. E. Uutoni',
    submissionDate: '2025-03-01',
    standingCommittee: 'CC-SOC',
    committeeReviewDate: '2025-03-10',
    dateDecided: '2025-03-15',
    approvalDate: '2025-03-15',
    communicatedDate: '2025-03-17',
    legalBasis: 'Cabinet Resolution No. 1/15.03.25',
    minuteReference: 'CAB/MIN/1/2025',
    status: 'In Progress',
    deadline: '2028-03-31',
    targetCompletionDate: '2028-03-31',
    actualCompletionDate: null,
    leadMinistryId: 'MURDH',
    responsibleMinistries: [
      { ministryId: 'MURDH', role: 'Lead', ministryName: 'Ministry of Urban & Rural Development, Housing' },
      { ministryId: 'MWTI', role: 'Co-lead', ministryName: 'Ministry of Works, Transport & Infrastructure' },
      { ministryId: 'MFSGM', role: 'Support', ministryName: 'Ministry of Finance & Social Grants Management' }
    ],
    ministryAssignments: [
      { ministryId: 'MURDH', role: 'Lead', acknowledged: true, acknowledgedDate: '2025-03-18', implementationPlanSubmitted: true, implementationPlanDate: '2025-03-28' },
      { ministryId: 'MWTI', role: 'Co-lead', acknowledged: true, acknowledgedDate: '2025-03-19', implementationPlanSubmitted: true, implementationPlanDate: '2025-03-30' },
      { ministryId: 'MFSGM', role: 'Support', acknowledged: true, acknowledgedDate: '2025-03-19', implementationPlanSubmitted: false, implementationPlanDate: null }
    ],
    ndp6PillarId: 2,
    ndp6Pillar: 'Social Transformation',
    ndp6ThematicArea: 'Health & Wellness',
    ndp6FocusArea: 'Hospital Infrastructure',
    budgetImplication: {
      hasBudgetImpact: true,
      estimatedCost: 2500000000,
      fundingSource: 'National Budget',
      financialYear: '2025/2026'
    },
    linkedProjectIds: ['NAM-2025-0012'],
    relatedDecisions: [],
    tags: ['housing', 'infrastructure', 'urban-development', 'mass-housing'],
    totalDirectives: 2,
    completedDirectives: 0,
    overdueDirectives: 0,
    overallProgress: 52,
    escalationLevel: 0,
    escalationHistory: [],
    attachments: [
      { id: 'ATT-001', name: 'Cabinet Memorandum — Housing Programme Acceleration', type: 'MEMORANDUM', fileType: 'pdf', uploadedBy: 'MURDH', uploadedDate: '2025-03-01', classification: 'RESTRICTED' }
    ],
    auditTrail: [
      { date: '2025-03-01T09:00:00Z', action: 'SUBMITTED', actor: 'Minister MURDH', notes: 'Memorandum submitted' },
      { date: '2025-03-10T14:00:00Z', action: 'COMMITTEE_REVIEWED', actor: 'CC-SOC', notes: 'Recommended for approval with budget conditions' },
      { date: '2025-03-15T10:00:00Z', action: 'APPROVED', actor: 'Cabinet', notes: 'Approved unanimously' },
      { date: '2025-03-17T08:00:00Z', action: 'COMMUNICATED', actor: 'Cabinet Secretariat', notes: 'CDN issued to MURDH, MWTI, MFSGM' },
      { date: '2025-03-20T09:00:00Z', action: 'DIRECTIVES_ISSUED', actor: "PM's Office", notes: '2 directives assigned' }
    ],
    createdBy: 'Secretary to Cabinet',
    lastUpdated: '2025-06-15T10:00:00Z'
  },

  // ── 2. EMERGENCY / Overdue / NDP6 Pillar 3 ──
  {
    id: 'CAB-2025-002',
    referenceNumber: 'CAB/2/2025',
    cdn: '4TH/15.02.25/003',
    meetingId: 'CM-2025-04',
    title: 'National Drought Emergency Response — Kunene and Omaheke Regions',
    description: 'Cabinet declared a drought emergency in Kunene and Omaheke regions and directed immediate relief measures including fodder distribution, borehole monitoring, and livestock off-take programmes.',
    fullText: 'Cabinet, having received the report from the Minister of Agriculture, Fisheries, Water and Land Reform on the severe drought conditions in Kunene and Omaheke, and noting that livestock mortality has reached 15% in affected areas, resolves: (1) A drought emergency is declared for Kunene and Omaheke regions; (2) MAFWLR shall establish a real-time drought monitoring system within 120 days; (3) Emergency fodder and water shall be distributed within 60 days; (4) MEFT to provide drought classification data.',
    category: 'EMERGENCY',
    priority: 'critical',
    classification: 'PUBLIC',
    originatingMinistry: 'MAFWLR',
    originatingMinister: 'Hon. C. Schlettwein',
    submissionDate: '2025-02-10',
    standingCommittee: 'CC-ECO',
    committeeReviewDate: '2025-02-12',
    dateDecided: '2025-02-15',
    approvalDate: '2025-02-15',
    communicatedDate: '2025-02-17',
    legalBasis: 'Cabinet Resolution No. 3/15.02.25; Disaster Risk Management Act, 2012',
    minuteReference: 'CAB/MIN/3/2025',
    status: 'Overdue',
    deadline: '2025-06-30',
    targetCompletionDate: '2025-06-30',
    actualCompletionDate: null,
    leadMinistryId: 'MAFWLR',
    responsibleMinistries: [
      { ministryId: 'MAFWLR', role: 'Lead', ministryName: 'Ministry of Agriculture, Fisheries, Water & Land Reform' },
      { ministryId: 'MEFT', role: 'Support', ministryName: 'Ministry of Environment, Forestry & Tourism' }
    ],
    ministryAssignments: [
      { ministryId: 'MAFWLR', role: 'Lead', acknowledged: true, acknowledgedDate: '2025-02-18', implementationPlanSubmitted: true, implementationPlanDate: '2025-02-25' },
      { ministryId: 'MEFT', role: 'Support', acknowledged: true, acknowledgedDate: '2025-02-19', implementationPlanSubmitted: true, implementationPlanDate: '2025-02-28' }
    ],
    ndp6PillarId: 3,
    ndp6Pillar: 'Environmental Sustainability',
    ndp6ThematicArea: 'Climate Action',
    ndp6FocusArea: 'Disaster Management',
    budgetImplication: {
      hasBudgetImpact: true,
      estimatedCost: 180000000,
      fundingSource: 'Contingency Fund',
      financialYear: '2024/2025'
    },
    linkedProjectIds: [],
    relatedDecisions: [],
    tags: ['drought', 'emergency', 'kunene', 'omaheke', 'livestock', 'water'],
    totalDirectives: 2,
    completedDirectives: 1,
    overdueDirectives: 1,
    overallProgress: 78,
    escalationLevel: 2,
    escalationHistory: [
      { date: '2025-07-01T09:00:00Z', level: 1, trigger: 'Directive DIR-2025-002-01 missed deadline', action: 'ED notified by OPM' },
      { date: '2025-07-15T09:00:00Z', level: 2, trigger: 'No remediation plan received within 7 days', action: 'Minister MAFWLR briefed by PM' }
    ],
    attachments: [
      { id: 'ATT-002', name: 'Cabinet Memorandum — Drought Emergency', type: 'MEMORANDUM', fileType: 'pdf', uploadedBy: 'MAFWLR', uploadedDate: '2025-02-10', classification: 'PUBLIC' },
      { id: 'ATT-003', name: 'Drought Impact Assessment Report', type: 'REPORT', fileType: 'pdf', uploadedBy: 'MAFWLR', uploadedDate: '2025-02-10', classification: 'PUBLIC' }
    ],
    auditTrail: [
      { date: '2025-02-10T09:00:00Z', action: 'SUBMITTED', actor: 'Minister MAFWLR', notes: 'Emergency memorandum submitted' },
      { date: '2025-02-12T11:00:00Z', action: 'COMMITTEE_REVIEWED', actor: 'CC-ECO', notes: 'Fast-tracked — recommended immediate action' },
      { date: '2025-02-15T10:00:00Z', action: 'APPROVED', actor: 'Cabinet', notes: 'Approved unanimously under emergency provisions' },
      { date: '2025-02-17T08:00:00Z', action: 'COMMUNICATED', actor: 'Cabinet Secretariat', notes: 'CDN issued with urgent flag' },
      { date: '2025-02-18T09:00:00Z', action: 'DIRECTIVES_ISSUED', actor: "PM's Office", notes: '2 directives assigned to MAFWLR' },
      { date: '2025-07-01T09:00:00Z', action: 'ESCALATED', actor: 'OPM Monitoring', notes: 'Escalated to Level 1 — DIR-2025-002-01 overdue' },
      { date: '2025-07-15T09:00:00Z', action: 'ESCALATED', actor: "PM's Office", notes: 'Escalated to Level 2 — Minister briefed' }
    ],
    createdBy: 'Secretary to Cabinet',
    lastUpdated: '2025-07-15T10:00:00Z'
  },

  // ── 3. POLICY / In Progress / NDP6 Pillar 4 ──
  {
    id: 'CAB-2025-003',
    referenceNumber: 'CAB/3/2025',
    cdn: '6TH/30.04.25/002',
    meetingId: 'CM-2025-06',
    title: 'Digital Government Transformation Strategy',
    description: 'Cabinet approved a comprehensive digital transformation strategy for the public service, mandating the development of an e-Cabinet platform, government-wide cybersecurity framework, and digital identity integration.',
    fullText: 'Cabinet, having considered the memorandum from the Minister of Information and Communication Technology on digital government readiness, resolves: (1) MICT shall develop and deploy an e-Cabinet memorandum submission platform by March 2026; (2) A government-wide cybersecurity policy aligned with ISO 27001 shall be developed by December 2025; (3) All O/M/As shall designate Chief Information Officers within 60 days.',
    category: 'POLICY',
    priority: 'high',
    classification: 'RESTRICTED',
    originatingMinistry: 'MICT',
    originatingMinister: 'Hon. P. Mushelenga',
    submissionDate: '2025-04-15',
    standingCommittee: 'CC-GOV',
    committeeReviewDate: '2025-04-25',
    dateDecided: '2025-04-30',
    approvalDate: '2025-04-30',
    communicatedDate: '2025-05-02',
    legalBasis: 'Cabinet Resolution No. 2/30.04.25',
    minuteReference: 'CAB/MIN/2/2025',
    status: 'In Progress',
    deadline: '2026-03-31',
    targetCompletionDate: '2026-03-31',
    actualCompletionDate: null,
    leadMinistryId: 'MICT',
    responsibleMinistries: [
      { ministryId: 'MICT', role: 'Lead', ministryName: 'Ministry of Information & Communication Technology' },
      { ministryId: 'OPM', role: 'Co-lead', ministryName: 'Office of the Prime Minister' }
    ],
    ministryAssignments: [
      { ministryId: 'MICT', role: 'Lead', acknowledged: true, acknowledgedDate: '2025-05-03', implementationPlanSubmitted: true, implementationPlanDate: '2025-05-12' },
      { ministryId: 'OPM', role: 'Co-lead', acknowledged: true, acknowledgedDate: '2025-05-03', implementationPlanSubmitted: true, implementationPlanDate: '2025-05-15' }
    ],
    ndp6PillarId: 4,
    ndp6Pillar: 'Good Governance',
    ndp6ThematicArea: 'Public Service Reform',
    ndp6FocusArea: 'Digitalization',
    budgetImplication: {
      hasBudgetImpact: true,
      estimatedCost: 85000000,
      fundingSource: 'Development Budget + EU Digital Cooperation Grant',
      financialYear: '2025/2026'
    },
    linkedProjectIds: [],
    relatedDecisions: [],
    tags: ['digital-government', 'e-cabinet', 'cybersecurity', 'ict', 'modernisation'],
    totalDirectives: 2,
    completedDirectives: 0,
    overdueDirectives: 0,
    overallProgress: 58,
    escalationLevel: 0,
    escalationHistory: [],
    attachments: [
      { id: 'ATT-004', name: 'Cabinet Memorandum — Digital Government Strategy', type: 'MEMORANDUM', fileType: 'pdf', uploadedBy: 'MICT', uploadedDate: '2025-04-15', classification: 'RESTRICTED' }
    ],
    auditTrail: [
      { date: '2025-04-15T09:00:00Z', action: 'SUBMITTED', actor: 'Minister MICT', notes: 'Memorandum submitted' },
      { date: '2025-04-25T14:00:00Z', action: 'COMMITTEE_REVIEWED', actor: 'CC-GOV', notes: 'Recommended with cybersecurity provisions strengthened' },
      { date: '2025-04-30T10:00:00Z', action: 'APPROVED', actor: 'Cabinet', notes: 'Approved with amendments' },
      { date: '2025-05-02T08:00:00Z', action: 'COMMUNICATED', actor: 'Cabinet Secretariat', notes: 'CDN issued to MICT and all O/M/As' },
      { date: '2025-05-05T09:00:00Z', action: 'DIRECTIVES_ISSUED', actor: "PM's Office", notes: '2 directives assigned' }
    ],
    createdBy: 'Secretary to Cabinet',
    lastUpdated: '2025-10-01T10:00:00Z'
  },

  // ── 4. LEGISLATION / Stalled / NDP6 Pillar 4 ──
  {
    id: 'CAB-2025-004',
    referenceNumber: 'CAB/4/2025',
    cdn: '3RD/15.01.25/005',
    meetingId: 'CM-2025-03',
    title: 'Public Procurement Reform Amendment Bill',
    description: 'Cabinet directed the drafting of the Public Procurement Amendment Bill to introduce mandatory e-procurement, enhanced local content provisions, and SME preferential scoring to improve transparency and value for money in government procurement.',
    fullText: 'Cabinet, having considered the memorandum from the Minister of Finance and Social Grants Management on procurement inefficiencies and the Auditor General\'s findings on irregular expenditure, resolves: (1) MJL shall draft a Public Procurement Amendment Bill within 6 months; (2) The Bill shall mandate electronic procurement for all tenders above N$1 million; (3) Local content and SME preference provisions shall be strengthened; (4) MFSGM shall prepare a regulatory impact assessment.',
    category: 'LEGISLATION',
    priority: 'high',
    classification: 'CONFIDENTIAL',
    originatingMinistry: 'MFSGM',
    originatingMinister: 'Hon. I. Nghimtina',
    submissionDate: '2025-01-08',
    standingCommittee: 'CC-ECO',
    committeeReviewDate: '2025-01-12',
    dateDecided: '2025-01-15',
    approvalDate: '2025-01-15',
    communicatedDate: '2025-01-17',
    legalBasis: 'Cabinet Resolution No. 5/15.01.25',
    minuteReference: 'CAB/MIN/5/2025',
    status: 'Stalled',
    deadline: '2025-06-30',
    targetCompletionDate: '2025-06-30',
    actualCompletionDate: null,
    leadMinistryId: 'MJL',
    responsibleMinistries: [
      { ministryId: 'MJL', role: 'Lead', ministryName: 'Ministry of Justice & Labour Relations' },
      { ministryId: 'MFSGM', role: 'Co-lead', ministryName: 'Ministry of Finance & Social Grants Management' }
    ],
    ministryAssignments: [
      { ministryId: 'MJL', role: 'Lead', acknowledged: true, acknowledgedDate: '2025-01-18', implementationPlanSubmitted: true, implementationPlanDate: '2025-01-28' },
      { ministryId: 'MFSGM', role: 'Co-lead', acknowledged: true, acknowledgedDate: '2025-01-20', implementationPlanSubmitted: true, implementationPlanDate: '2025-01-30' }
    ],
    ndp6PillarId: 4,
    ndp6Pillar: 'Good Governance',
    ndp6ThematicArea: 'Public Service Reform',
    ndp6FocusArea: 'Accountability',
    budgetImplication: {
      hasBudgetImpact: true,
      estimatedCost: 15000000,
      fundingSource: 'National Budget',
      financialYear: '2025/2026'
    },
    linkedProjectIds: [],
    relatedDecisions: [],
    tags: ['procurement', 'legislation', 'e-procurement', 'transparency', 'sme'],
    totalDirectives: 1,
    completedDirectives: 0,
    overdueDirectives: 1,
    overallProgress: 40,
    escalationLevel: 3,
    escalationHistory: [
      { date: '2025-07-05T09:00:00Z', level: 1, trigger: 'Directive deadline missed', action: 'ED MJL notified' },
      { date: '2025-07-20T09:00:00Z', level: 2, trigger: 'No remediation within 14 days', action: 'Minister MJL briefed' },
      { date: '2025-08-15T09:00:00Z', level: 3, trigger: 'AG review bottleneck unresolved', action: 'PM intervention requested' }
    ],
    attachments: [
      { id: 'ATT-005', name: 'Cabinet Memorandum — Procurement Reform', type: 'MEMORANDUM', fileType: 'pdf', uploadedBy: 'MFSGM', uploadedDate: '2025-01-08', classification: 'CONFIDENTIAL' }
    ],
    auditTrail: [
      { date: '2025-01-08T09:00:00Z', action: 'SUBMITTED', actor: 'Minister MFSGM', notes: 'Memorandum submitted' },
      { date: '2025-01-12T14:00:00Z', action: 'COMMITTEE_REVIEWED', actor: 'CC-ECO', notes: 'Recommended for approval' },
      { date: '2025-01-15T10:00:00Z', action: 'APPROVED', actor: 'Cabinet', notes: 'Approved' },
      { date: '2025-01-17T08:00:00Z', action: 'COMMUNICATED', actor: 'Cabinet Secretariat', notes: 'CDN issued to MJL and MFSGM' },
      { date: '2025-01-18T09:00:00Z', action: 'DIRECTIVES_ISSUED', actor: "PM's Office", notes: '1 directive assigned' },
      { date: '2025-07-05T09:00:00Z', action: 'ESCALATED', actor: 'OPM Monitoring', notes: 'Escalated to Level 1' },
      { date: '2025-07-20T09:00:00Z', action: 'ESCALATED', actor: "PM's Office", notes: 'Escalated to Level 2' },
      { date: '2025-08-15T09:00:00Z', action: 'ESCALATED', actor: "PM's Office", notes: 'Escalated to Level 3 — AG bottleneck' }
    ],
    createdBy: 'Secretary to Cabinet',
    lastUpdated: '2025-08-15T10:00:00Z'
  },

  // ── 5. POLICY / Completed / NDP6 Pillar 2 ──
  {
    id: 'CAB-2025-005',
    referenceNumber: 'CAB/5/2024',
    cdn: '18TH/01.09.24/007',
    meetingId: 'CM-2024-18',
    title: 'National School Feeding Programme Expansion — Northern Regions',
    description: 'Cabinet approved the expansion of the National School Feeding Programme to cover all schools in Kavango East and Zambezi regions lacking existing programmes, including nutritional monitoring through MHSS.',
    fullText: 'Cabinet, having considered the memorandum from the Minister of Education, Innovation, Youth, Sport, Arts and Culture, and noting that 147 schools in Kavango East and Zambezi lack feeding programmes while malnutrition indicators remain above 25% in these regions, resolves: (1) MEIYSC shall expand the school feeding programme to all 147 identified schools by March 2025; (2) MHSS shall develop a nutrition monitoring framework; (3) N$42 million per annum shall be allocated from the education vote.',
    category: 'POLICY',
    priority: 'high',
    classification: 'PUBLIC',
    originatingMinistry: 'MEIYSC',
    originatingMinister: 'Hon. A. Muharukua',
    submissionDate: '2024-08-20',
    standingCommittee: 'CC-SOC',
    committeeReviewDate: '2024-08-28',
    dateDecided: '2024-09-01',
    approvalDate: '2024-09-01',
    communicatedDate: '2024-09-03',
    legalBasis: 'Cabinet Resolution No. 7/01.09.24',
    minuteReference: 'CAB/MIN/7/2024',
    status: 'Completed',
    deadline: '2025-03-31',
    targetCompletionDate: '2025-03-31',
    actualCompletionDate: '2025-03-28',
    leadMinistryId: 'MEIYSC',
    responsibleMinistries: [
      { ministryId: 'MEIYSC', role: 'Lead', ministryName: 'Ministry of Education, Innovation, Youth, Sport, Arts & Culture' },
      { ministryId: 'MHSS', role: 'Support', ministryName: 'Ministry of Health & Social Services' },
      { ministryId: 'MFSGM', role: 'Support', ministryName: 'Ministry of Finance & Social Grants Management' }
    ],
    ministryAssignments: [
      { ministryId: 'MEIYSC', role: 'Lead', acknowledged: true, acknowledgedDate: '2024-09-04', implementationPlanSubmitted: true, implementationPlanDate: '2024-09-12' },
      { ministryId: 'MHSS', role: 'Support', acknowledged: true, acknowledgedDate: '2024-09-05', implementationPlanSubmitted: true, implementationPlanDate: '2024-09-15' },
      { ministryId: 'MFSGM', role: 'Support', acknowledged: true, acknowledgedDate: '2024-09-05', implementationPlanSubmitted: true, implementationPlanDate: '2024-09-16' }
    ],
    ndp6PillarId: 2,
    ndp6Pillar: 'Social Transformation',
    ndp6ThematicArea: 'Education & Skills',
    ndp6FocusArea: 'Primary Education',
    budgetImplication: {
      hasBudgetImpact: true,
      estimatedCost: 42000000,
      fundingSource: 'Education Vote',
      financialYear: '2024/2025'
    },
    linkedProjectIds: [],
    relatedDecisions: [],
    tags: ['school-feeding', 'nutrition', 'education', 'northern-regions', 'social-protection'],
    totalDirectives: 2,
    completedDirectives: 2,
    overdueDirectives: 0,
    overallProgress: 100,
    escalationLevel: 0,
    escalationHistory: [],
    attachments: [
      { id: 'ATT-006', name: 'Cabinet Memorandum — School Feeding Expansion', type: 'MEMORANDUM', fileType: 'pdf', uploadedBy: 'MEIYSC', uploadedDate: '2024-08-20', classification: 'PUBLIC' },
      { id: 'ATT-007', name: 'Completion Report — School Feeding Programme', type: 'REPORT', fileType: 'pdf', uploadedBy: 'MEIYSC', uploadedDate: '2025-03-28', classification: 'PUBLIC' }
    ],
    auditTrail: [
      { date: '2024-08-20T09:00:00Z', action: 'SUBMITTED', actor: 'Minister MEIYSC', notes: 'Memorandum submitted' },
      { date: '2024-08-28T14:00:00Z', action: 'COMMITTEE_REVIEWED', actor: 'CC-SOC', notes: 'Recommended for approval — priority intervention' },
      { date: '2024-09-01T10:00:00Z', action: 'APPROVED', actor: 'Cabinet', notes: 'Approved unanimously' },
      { date: '2024-09-03T08:00:00Z', action: 'COMMUNICATED', actor: 'Cabinet Secretariat', notes: 'CDN issued' },
      { date: '2024-09-05T09:00:00Z', action: 'DIRECTIVES_ISSUED', actor: "PM's Office", notes: '2 directives assigned' },
      { date: '2025-03-28T10:00:00Z', action: 'COMPLETED', actor: 'OPM Monitoring', notes: 'All directives completed. Programme operational.' }
    ],
    createdBy: 'Secretary to Cabinet',
    lastUpdated: '2025-03-28T12:00:00Z'
  },

  // ── 6. BUDGET / Pending / NDP6 Pillar 1 ──
  {
    id: 'CAB-2025-006',
    referenceNumber: 'CAB/6/2025',
    cdn: '10TH/15.08.25/004',
    meetingId: 'CM-2025-10',
    title: 'Green Scheme Irrigation Programme — Expenditure Review and Continuation',
    description: 'Cabinet directed a comprehensive value-for-money review of all Green Scheme irrigation projects before approving additional funding for the next phase, including project NAM-2024-0882.',
    fullText: 'Cabinet, having noted the Auditor General\'s concerns regarding cost overruns in the Green Scheme programme and the at-risk status of NAM-2024-0882, resolves: (1) MAFWLR and MFSGM shall conduct a value-for-money audit of all Green Scheme projects 2020-2024; (2) No additional funding shall be released until the audit is completed; (3) Audit findings shall be reported to Cabinet by December 2025.',
    category: 'BUDGET',
    priority: 'medium',
    classification: 'CONFIDENTIAL',
    originatingMinistry: 'MFSGM',
    originatingMinister: 'Hon. I. Nghimtina',
    submissionDate: '2025-08-05',
    standingCommittee: 'CC-ECO',
    committeeReviewDate: '2025-08-12',
    dateDecided: '2025-08-15',
    approvalDate: '2025-08-15',
    communicatedDate: '2025-08-18',
    legalBasis: 'Cabinet Resolution No. 4/15.08.25; State Finance Act, 1991',
    minuteReference: 'CAB/MIN/4/2025',
    status: 'Pending',
    deadline: '2025-12-31',
    targetCompletionDate: '2025-12-31',
    actualCompletionDate: null,
    leadMinistryId: 'MAFWLR',
    responsibleMinistries: [
      { ministryId: 'MAFWLR', role: 'Lead', ministryName: 'Ministry of Agriculture, Fisheries, Water & Land Reform' },
      { ministryId: 'MFSGM', role: 'Co-lead', ministryName: 'Ministry of Finance & Social Grants Management' }
    ],
    ministryAssignments: [
      { ministryId: 'MAFWLR', role: 'Lead', acknowledged: true, acknowledgedDate: '2025-08-19', implementationPlanSubmitted: false, implementationPlanDate: null },
      { ministryId: 'MFSGM', role: 'Co-lead', acknowledged: true, acknowledgedDate: '2025-08-20', implementationPlanSubmitted: false, implementationPlanDate: null }
    ],
    ndp6PillarId: 1,
    ndp6Pillar: 'Economic Advancement',
    ndp6ThematicArea: 'Industrialization',
    ndp6FocusArea: 'SME Support',
    budgetImplication: {
      hasBudgetImpact: true,
      estimatedCost: 5000000,
      fundingSource: 'National Budget (Audit costs)',
      financialYear: '2025/2026'
    },
    linkedProjectIds: ['NAM-2024-0882'],
    relatedDecisions: [],
    tags: ['green-scheme', 'irrigation', 'agriculture', 'audit', 'value-for-money'],
    totalDirectives: 1,
    completedDirectives: 0,
    overdueDirectives: 0,
    overallProgress: 0,
    escalationLevel: 0,
    escalationHistory: [],
    attachments: [
      { id: 'ATT-008', name: 'Cabinet Memorandum — Green Scheme Review', type: 'MEMORANDUM', fileType: 'pdf', uploadedBy: 'MFSGM', uploadedDate: '2025-08-05', classification: 'CONFIDENTIAL' }
    ],
    auditTrail: [
      { date: '2025-08-05T09:00:00Z', action: 'SUBMITTED', actor: 'Minister MFSGM', notes: 'Memorandum submitted' },
      { date: '2025-08-12T14:00:00Z', action: 'COMMITTEE_REVIEWED', actor: 'CC-ECO', notes: 'Recommended — expenditure freeze until audit completion' },
      { date: '2025-08-15T10:00:00Z', action: 'APPROVED', actor: 'Cabinet', notes: 'Approved' },
      { date: '2025-08-18T08:00:00Z', action: 'COMMUNICATED', actor: 'Cabinet Secretariat', notes: 'CDN issued to MAFWLR and MFSGM' },
      { date: '2025-08-20T09:00:00Z', action: 'DIRECTIVES_ISSUED', actor: "PM's Office", notes: '1 directive assigned' }
    ],
    createdBy: 'Secretary to Cabinet',
    lastUpdated: '2025-08-20T10:00:00Z'
  },

  // ── 7. ADMIN / Pending / NDP6 Pillar 1 — Cross-cutting (4 ministries) ──
  {
    id: 'CAB-2025-007',
    referenceNumber: 'CAB/7/2025',
    cdn: '11TH/01.10.25/002',
    meetingId: 'CM-2025-11',
    title: 'Renewable Energy Independent Power Producer Framework',
    description: 'Cabinet directed the development of a regulatory framework for renewable energy independent power producers to reduce Namibia\'s dependence on imported electricity and achieve 70% renewable generation by 2035.',
    fullText: 'Cabinet, having considered the memorandum from the Minister of Industrialisation, Mines and Energy on energy security and the need to diversify generation sources, resolves: (1) MIME shall develop an IPP framework for renewable energy within 9 months; (2) MEFT shall establish a fast-track environmental clearance process for solar and wind projects under 50MW; (3) MFSGM shall model fiscal incentives for renewable energy investment; (4) MWTI shall assess grid infrastructure upgrade requirements for renewable integration.',
    category: 'ADMIN',
    priority: 'high',
    classification: 'RESTRICTED',
    originatingMinistry: 'MIME',
    originatingMinister: 'Hon. T. Alweendo',
    submissionDate: '2025-09-22',
    standingCommittee: 'CC-ECO',
    committeeReviewDate: '2025-09-28',
    dateDecided: '2025-10-01',
    approvalDate: '2025-10-01',
    communicatedDate: '2025-10-03',
    legalBasis: 'Cabinet Resolution No. 2/01.10.25; Electricity Act, 2007',
    minuteReference: 'CAB/MIN/2/2025-10',
    status: 'Pending',
    deadline: '2026-06-30',
    targetCompletionDate: '2026-06-30',
    actualCompletionDate: null,
    leadMinistryId: 'MIME',
    responsibleMinistries: [
      { ministryId: 'MIME', role: 'Lead', ministryName: 'Ministry of Industrialisation, Mines & Energy' },
      { ministryId: 'MEFT', role: 'Co-lead', ministryName: 'Ministry of Environment, Forestry & Tourism' },
      { ministryId: 'MFSGM', role: 'Support', ministryName: 'Ministry of Finance & Social Grants Management' },
      { ministryId: 'MWTI', role: 'Support', ministryName: 'Ministry of Works, Transport & Infrastructure' }
    ],
    ministryAssignments: [
      { ministryId: 'MIME', role: 'Lead', acknowledged: true, acknowledgedDate: '2025-10-04', implementationPlanSubmitted: false, implementationPlanDate: null },
      { ministryId: 'MEFT', role: 'Co-lead', acknowledged: true, acknowledgedDate: '2025-10-05', implementationPlanSubmitted: false, implementationPlanDate: null },
      { ministryId: 'MFSGM', role: 'Support', acknowledged: false, acknowledgedDate: null, implementationPlanSubmitted: false, implementationPlanDate: null },
      { ministryId: 'MWTI', role: 'Support', acknowledged: false, acknowledgedDate: null, implementationPlanSubmitted: false, implementationPlanDate: null }
    ],
    ndp6PillarId: 1,
    ndp6Pillar: 'Economic Advancement',
    ndp6ThematicArea: 'Infrastructure Development',
    ndp6FocusArea: 'Energy Security',
    budgetImplication: {
      hasBudgetImpact: true,
      estimatedCost: 12000000,
      fundingSource: 'Development Budget + GIZ Cooperation',
      financialYear: '2025/2026'
    },
    linkedProjectIds: [],
    relatedDecisions: [],
    tags: ['renewable-energy', 'ipp', 'electricity', 'solar', 'wind', 'energy-security'],
    totalDirectives: 2,
    completedDirectives: 0,
    overdueDirectives: 0,
    overallProgress: 0,
    escalationLevel: 0,
    escalationHistory: [],
    attachments: [
      { id: 'ATT-009', name: 'Cabinet Memorandum — Renewable Energy IPP Framework', type: 'MEMORANDUM', fileType: 'pdf', uploadedBy: 'MIME', uploadedDate: '2025-09-22', classification: 'RESTRICTED' }
    ],
    auditTrail: [
      { date: '2025-09-22T09:00:00Z', action: 'SUBMITTED', actor: 'Minister MIME', notes: 'Memorandum submitted' },
      { date: '2025-09-28T14:00:00Z', action: 'COMMITTEE_REVIEWED', actor: 'CC-ECO', notes: 'Recommended with MEFT fast-track provision added' },
      { date: '2025-10-01T10:00:00Z', action: 'APPROVED', actor: 'Cabinet', notes: 'Approved' },
      { date: '2025-10-03T08:00:00Z', action: 'COMMUNICATED', actor: 'Cabinet Secretariat', notes: 'CDN issued to MIME, MEFT, MFSGM, MWTI' },
      { date: '2025-10-08T09:00:00Z', action: 'DIRECTIVES_ISSUED', actor: "PM's Office", notes: '2 directives assigned' }
    ],
    createdBy: 'Secretary to Cabinet',
    lastUpdated: '2025-10-15T10:00:00Z'
  }
];

// ---------------------------------------------------------------------------
// 3.5  Summary Statistics (pre-computed for dashboard)
// ---------------------------------------------------------------------------
const stats = {
  totalDecisions: 7,
  activeDecisions: 4,
  completedDecisions: 1,
  overdueDecisions: 1,
  stalledDecisions: 1,
  totalDirectives: 14,
  completedDirectives: 4,
  overdueDirectives: 2,
  totalAssignments: 22,
  completedAssignments: 8,
  avgImplementationRate: 47,
  crossCuttingDecisions: 4,
  acknowledgedOnTime: 6,
  acknowledgmentRate: 85.7,
  byCategory: {
    POLICY: 3,
    STATUTORY: 0,
    ADMIN: 1,
    LEGISLATION: 1,
    EMERGENCY: 1,
    BUDGET: 1
  },
  byPriority: {
    critical: 2,
    high: 4,
    medium: 1,
    standard: 0
  }
};

// ---------------------------------------------------------------------------
// Named export
// ---------------------------------------------------------------------------
export const CABINET_DECISIONS_DATA = {
  decisions,
  directives,
  assignments,
  stats
};
